import { Component, Prop, Vue, Emit } from 'vue-property-decorator'; 
import AlertEventBus, { IAlert } from 'Events/AlertEventBus'; 
import ComponentEventBus, { IComponentWrapper, Events as ComponentWrapperEvents } from 'Events/ComponentWrapperEventBus';


export const name = 'alert-component';

@Component({ 
    template: '#alert-component-template', 
    //name: 'delivery-address' 
}) 
export default class AlertComponent extends Vue { 
    
    @Prop() 
    public customClass: string; 
    
    protected useTimeout: boolean = true; 
    protected type: string = name;
    
    public obj: IAlert = <any>{}; 
    
    mounted() { 
        
        const self = this;
        setTimeout(() => { 
            if(!(<any>this.$parent).useTimeout)return;    
            this.close();
        },5000); 
        
        
        AlertEventBus.$on('show-alert', (value: IAlert) => { 
            self.obj = value; 
            // self.obj.currentComponent = self; 
        }); 
    } 
    
    
    close(){
        console.debug('alert id: ',(<any>this.$parent).type);
        ComponentEventBus.$emit(ComponentWrapperEvents.REMOVE, {type: (<any>this.$parent).type}); 
    }
    
    
    
} 

Vue.component(name, AlertComponent);